import React, { useEffect } from "react";
import UnregisteredCompanyUser from "../misc/UnregisteredCompanyUser";
import RegisteredUser from "../misc/RegisteredUser";
import { setTitle } from "../../../store/slices/navbar";
import AnimatedPage from "../../../components/animation/AnimatedPage";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_user_profile } from "../../../service/api/user-profile";

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector(({ userProfile }) => userProfile.profile);
  const profileLoading = useAppSelector(
    ({ userProfile }) => userProfile.loading,
  );
  const profileError = useAppSelector(({ userProfile }) => userProfile.error);
  const hasCompany = !!profile?.has_company;

  const onLoad = React.useCallback(() => {
    dispatch(setTitle("Dashboard"));
  }, [dispatch]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  useEffect(() => {
    void get_user_profile(dispatch);
  }, [dispatch]);

  return (
    <AnimatedPage className="mb-12">
      {profileLoading ? (
        <p role="status">Loading your profile...</p>
      ) : profile ? (
        hasCompany ? (
          <RegisteredUser />
        ) : (
          <UnregisteredCompanyUser />
        )
      ) : (
        <div role="alert" className="text-red-700">
          {profileError || "Unable to determine your company status."}
          <button
            type="button"
            className="ml-2 underline"
            onClick={() => void get_user_profile(dispatch)}
          >
            Try again
          </button>
        </div>
      )}
    </AnimatedPage>
  );
};

export default Dashboard;
